import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@/core/components/ui/stack";
import type { ApInvoice } from "@/accounts-payable/types";
import { cn } from "@/core/utils/utils";

export const vendorCol: ColumnDef<ApInvoice> = {
  id: "vendor",
  header: "Vendor",
  accessorFn: (row) => row.vendor_name,
  meta: { size: "260px" },
  cell: ({ row }) => (
    <Stack gap="xs">
      <span className="font-medium">{row.original.vendor_name}</span>
      <span
        className={cn("text-sm text-tertiary-text", {
          italic: !row.original.service_address,
        })}
      >
        {row.original.service_address ?? "No service address"}
      </span>
    </Stack>
  ),
};
